
<div 
  class="chip-dropdown"
  (mouseleave)="closeDropdown()"
>
  <!-- Chip Display -->
  <div *ngIf="selectedOption">
    <p>
      <up-chip-set>
        <up-chip 
          class="chip-color" 
          chip-cancel="true" 
          [disabled]="isReadOnly" 
          (chipCanceled)="clearSelection()"
        >
          {{ selectedOption }}
          <span *ngIf="!showLabel">{{ fieldName | lowercase }}</span>
        </up-chip>
      </up-chip-set>
    </p>
  </div>

  <!-- Dropdown for selection -->
  @if (!selectedOption) {
    <div 
      class="dropdown-wrapper" 
      [class.open]="dropdownOpen"
      [attr.aria-invalid]="showError ? 'true' : null"
      >
      <div 
        class="dropdown-header" 
        role="button" 
        tabindex="0"
        (click)="toggleDropdown()" 
        (keydown.enter)="toggleDropdown()" 
        (keydown.space)="toggleDropdown()"
        (blur)="onBlur()"
        [attr.aria-expanded]="dropdownOpen"
        aria-haspopup="listbox"
      >
        <span>{{ selectedOption || fieldName }}</span>
        <span class="twisty">{{ dropdownOpen ? '▲' : '▼' }}</span>
      </div>

      @if (dropdownOpen) {
        <ul 
          [ngClass]="isFromTransload ? 'dropdown-options' : 'dropdown-options-one'" 
          class="dropdown-options"
          role="listbox"
        >
          @for (option of options; track $index) {
            <li 
              role="option" 
              tabindex="0"
              [attr.aria-selected]="option === selectedOption"
              (click)="selectOption(option)"
              (keydown.enter)="selectOption(option)"
              (keydown.space)="selectOption(option)"
              (blur)="onBlur()"
            >
              {{ option }}
            </li>
          }
        </ul>
      }
    </div>
  }
  <!-- Messages -->
  @if (showWarning) {
    <div class="hint hint-warning" role="note">
      {{ fieldName }} is required.
    </div>
  }
  @if (showError) {
    <div class="hint hint-error" role="alert">
      {{ fieldName }} is required.
    </div>
  }
</div>
